import React, { type FC } from "react";
import { useDivisionFilterSeed } from "@app/session-defaults/useDivisionFilterSeed";
import { BoType } from "@src/api/bo";
import { DivisionType } from "@src/api/dictionaries/divisions";
import { BusinessForm } from "@src/components/business-form";
import { BoStateSelect, DivisionSearchSelect } from "@src/components/business-data-entry";
import { Input } from "@shared/ui/input";
import { FilterFormPanel } from "@shared/ui/form-panel";
import type { StockOrderFilter } from "../../../../../../api/stockOrders";
import type { ListFilterPanelProps } from "../../../../../../shared/listFilterPanel";
import { stockPlacementFilterFormConfig, type StockPlacementFilterFormValues } from "./stockPlacementFilter.form-config";

/** Пропсы компонента {@link StockPlacementFilterForm}. */
export type StockPlacementFilterFormProps = ListFilterPanelProps<StockOrderFilter>;

/** Форма фильтра приходных ордеров для размещения ТМЦ. */
export const StockPlacementFilterForm: FC<StockPlacementFilterFormProps> = ({ initialFilter, onApply }) => {
    const seed = useDivisionFilterSeed<StockPlacementFilterFormValues>("divisionCode", {
        filter: { Types: [DivisionType.Склад] },
    });

    return (
        <FilterFormPanel
            initialFilter={initialFilter}
            seed={seed}
            submissionMemory={{
                key: "stock.placementOrder.filter",
                schemaVersion: 1,
                fields: ["divisionCode", "stateCodes"],
            }}
            formProps={{ formConfig: stockPlacementFilterFormConfig }}
            toForm={(filter) => stockPlacementFilterFormConfig.toForm(filter)}
            toDomain={(values) => stockPlacementFilterFormConfig.toDomain(values)}
            onApply={onApply}
        >
            {(form) => (
                <>
                    <BusinessForm.Field name="num">
                        <Input {...form.field("num").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="divisionCode">
                        <DivisionSearchSelect
                            flt={{ Types: [DivisionType.Склад] }}
                            {...form.field("divisionCode").getSearchSelectProps((division) => division?.Code ?? null)}
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="stateCodes">
                        <BoStateSelect
                            {...form.field("stateCodes").getControlledPropsWithLabel()}
                            boType={BoType["Приходный ордер"]}
                            multiple
                            clearable
                            fullscreenTitle="Выберите статус(ы) ПО"
                        />
                    </BusinessForm.Field>
                </>
            )}
        </FilterFormPanel>
    );
};
